import React, { useState } from 'react';
import { LabelValue } from '../../../platform/types/LabelValue';
import { ButtonToggle } from '../../../ui/ButtonToggle';
import { useLocationScope } from '../../AppLocation';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ManageLegacyBillingHistoryView } from './billing/ManageLegacyBillingHistoryView';
import { ManageLegacyBillingPaymentsView } from './billing/ManageLegacyBillingPaymentsView';
import { ManageLegacyBillingSettingsView } from './billing/ManageLegacyBillingSettingsView';
import { ManageFrame } from './ManageFrame';

const viewOptions = [
    LabelValue('Settings', 'settings'),
    LabelValue('Payments', 'payments'),
    LabelValue('History', 'history'),
];

export const ManageLegacyBillingView = () => {
    useLocationScope('billing', 'Billing');

    const [view, setView] = useState('settings');

    return (
        <ManageFrame title="Billing">
            <Flexer flex="row" gap="1" align="center" padding="1 0">
                <ButtonToggle options={viewOptions} selected={view} onChange={setView} />
            </Flexer>
            <Flexer padding="1 0">
                {view === 'settings' && <ManageLegacyBillingSettingsView />}
                {view === 'payments' && <ManageLegacyBillingPaymentsView />}
                {view === 'history' && <ManageLegacyBillingHistoryView />}
            </Flexer>
        </ManageFrame>
    );
};
